<template>
  <!--  图片、pdf、docx 预览
            "docx-preview": "^0.1.4",
            "jszip": "^3.10.0",-->
  <div style="background: white !important">
    <a-modal
      title="文件预览"
      :visible="showDoc || showPdf || showImg"
      :maskClosable="false"
      @cancel="cancel"
    >
      <template slot="closeIcon">
        <my-icon icon="close-circle" class="closeIcon" />
      </template>
      <template slot="footer">
        <!-- <div v-if="showPdf" class="pdf-layout-page">
                    <my-button @click="changePdfPage(0)" :disabled="currentPage === 1" name="上一页" />
                    {{ currentPage }} / {{ pageCount }}
                    <my-button @click="changePdfPage(1)" :disabled="currentPage === pageCount" name="下一页" />
                </div>
                <my-button name="取消" @click="cancel" /> -->
        <!-- <el-button type="primary"   @click="cancel" >取消</el-button> -->
      </template>
      <div class="modal-body form">
        <div v-if="showPdf" class="pdf-layout-page">
          <!-- <my-button @click="changePdfPage(0)" :disabled="currentPage === 1" name="上一页" /> -->
          <el-button @click="changePdfPage(0)" :disabled="currentPage === 1"
            >上一页</el-button
          >
          {{ currentPage }} / {{ pageCount }}
          <!-- <my-button @click="changePdfPage(1)" :disabled="currentPage === pageCount" name="下一页" /> -->
          <el-button
            @click="changePdfPage(1)"
            :disabled="currentPage === pageCount"
            >下一页</el-button
          >
        </div>
        <!-- <el-button type="primary"   @click="cancel" >取消</el-button> -->
        <div v-if="showImg">
          <img :src="images" preview="1" preview-text="" style="width: 100%" />
        </div>
        <div v-show="showDoc" ref="word" id="wordDiv">
          <iframe v-if="fileUrl" frameborder="0" :src="fileUrl"> </iframe>
        </div>
        <div v-show="showPdf" class="pdf-layout" id="top">
          <pdfView
            ref="pdf"
            :src="pdfPath"
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
            @loaded="loadPdfHandler"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import pdfView from "vue-pdf";
import axios from "axios";
import mammoth from "mammoth";
import { docToDocx } from "../../api/api";
const docxPre = require("docx-preview");
window.JSZip = require("jszip");
export default {
  //   name: 'FilePreview',
  components: { pdfView },
  data() {
    return {
      showDoc: false, //判断如果是否为word文件显示
      showPdf: false, //判断如果是否为pdf文件显示
      showImg: false, //判断如果是否为图片显示
      fileUrl: "", //pdf链接
      images: "", //图片链接
      pdfPath: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      docType: "",
      docUrl: "",
      path: "",
    };
  },
  methods: {
    showView(filePaths) {
      let filePath = decodeURIComponent(filePaths);
      console.log(decodeURIComponent(filePaths));
      this.fileUrl = "";
      this.images = "";
      this.pdfPath = "";
      this.showPdf = false;
      this.showDoc = false;
      //$('#wordDiv').html("");
      let that = this;
      let type = filePath.split(".")[filePath.split(".").length - 1];
      if (
        type === "jpg" ||
        type === "png" ||
        type === "jpeg" ||
        type === "JPG" ||
        type === "PNG" ||
        type === "JPEG"
      ) {
        that.images = filePath;
        that.showImg = true;
      } else if (type === "pdf") {
        that.loadPdfHandler(); //重置pdf第一页展示
        that.pdfPath = filePath;
        that.showPdf = true;
      } else if (type === "doc") {
        //word预览
        // this.docType="doc",
        // that.docUrl = 'http://view.xdocin.com/xdoc?_xdoc=' + filePath
        // that.showDoc = true
        // $("<iframe :src='"+that.fileUrl+"' frameborder='0'></iframe>").appendTo($("#wordView"));
        let _params = {
          srcPath: filePath,
        };
        let that = this;
        docToDocx(_params).then((datas) => {
          let blob = new Blob([datas], { type: "docx" });
          that.showDoc = true;
          docxPre.renderAsync(blob, that.$refs.word);
          // let fileName = url.substring(url.lastIndexOf("/") + 1, url.length) // 得到文件名
        });
      } else if (type === "docx") {
        //word预览
        (this.docType = "docx"), (that.showDoc = true);
        that.previewWord(filePath);
      }
    },
    // 后端返回二进制流
    previewWord(filePath) {
      let that = this;
      // 这里需要提起打开弹窗，因为有时很找不到word的ref 会报错
      axios({
        method: "get",
        responseType: "blob", // 因为是流文件，所以要指定blob类型
        url: filePath,
      }).then(({ data }) => {
        debugger;
        docxPre.renderAsync(data, this.$refs.word);
      });
    },
    //pdf上一页下一页操作
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
        this.top();
      }
    },
    top() {
      document.querySelector("#top").scrollIntoView(true);
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    cancel() {
      this.showDoc = false; //判断如果是否为word文件显示
      this.showPdf = false; //判断如果是否为pdf文件显示
      this.showImg = false; //判断如果是否为图片显示
    },
    getPath() {
      this.path = window.location.hash.split("?")[1].split("=")[1];
    },
  },
  created() {
    this.getPath();
    this.showView(this.path);
  },
};
</script>
<style lang="less" scoped>
.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  /* width: 789.9pt !important; */
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: 800px !important;
}
</style>
<style >
.docx {
  /* margin-left: 155%!important; */
  margin-left: 800px !important;
}
.docx-wrapper {
  background: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/preview/FilePreviewByPhone.vue